export const VENMO_URL = 'https://venmo.com/u/TherapeuticRiding-atNormandyFa';
export const GIVEBUTTER_URL = 'https://givebutter.com/fYR0Ep';
